// Redux dependencies
import { applyMiddleware, createStore, compose } from 'redux';

// Thunk
import thunk from 'redux-thunk';

// Logger
import logger from 'redux-logger';

// Root reducer
import rootReducer from './redux/reducers';

const ConfigureStore = () => {
  /**
   * Add middlewares
   */
  const middlewares = [
    thunk
  ];

  // eslint-disable-next-line no-undef
  if (process.env.NODE_ENV) {
    middlewares.push(logger);
  }

  /**
   * Create store object
   */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  return { store };
};

export default ConfigureStore();
